import React from "react";

const PhoneNumberInput = ({
    type,
  label,
  id,
  placeholder,
  value,
  dialCode,
  isInvalid,
  onChangeDialCode,
  onChangeNumber,
  required
}) => {
  const dialCodes = ["+91"]; 

  const handleNumberChange = (e) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, ""); 
    if (inputValue.length <= 10) {
      onChangeNumber(inputValue);
    }
  };

  return (
    <div className="max-w-sm w-full ">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label} {required &&<span className="text-red-500">*</span>}
      </label> 
      <div className="flex  flex-col mt-1.5">
   

      <div className={`flex border h-10 rounded-lg transition-all ${
            isInvalid
              ? "border-red-500 shadow-md shadow-red-400/30"
              : "border-gray-300 focus-within:border-brand-500 focus-within:shadow-md focus-within:shadow-brand-500/30"
          }`}>
        <select
          className={`w-1/5 px-3 py-[7px] bg-white rounded-l-lg focus:outline-none`}
          value={dialCode}
          onChange={(e) => onChangeDialCode(e.target.value)}
        >
          {dialCodes.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
        <input
          type={type}
          id={id}
          className={`w-4/5 px-3 py-[7px] bg-white rounded-lg focus:outline-none focus:bg-transparent`}
          placeholder={placeholder}
          value={value}
          onChange={handleNumberChange}
        />
         </div>
       {isInvalid && <p className="mt-[2px] text-[12px] text-red-700">{isInvalid}</p>}
        
      </div>
    </div>
  );
};

export default PhoneNumberInput;
